export const fabletMixin = {
    getMusthaveKeywords: function(fablet, content) {
        let segments = fablet.split(';');
        let foundSegments = [];

        segments.forEach((segment) => {
            let mustHave = false;
            if (segment.indexOf('+', 0, 1) == 0) {
                segment = segment.substring(2, segment.length - 2);
                mustHave = true;
            }
            
            if (segment != null && segment != "") {
                let keywordsArray = segment.split('||');
                keywordsArray.forEach((keyWord) => {
                    if (mustHave && content.indexOf(keyWord) >= 0)
                    {
                        foundSegments.push(keyWord);
                    }
                })
            }
        })
        return foundSegments;
    }
}